var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 details__thumb"},[_c('img',{attrs:{"src":_vm.artwork.imagePreviewUrl}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff3f4eb2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/search_page/index/components/artworks_tab/row/artwork_image.vue
// module id = 400
// module chunks = 0 1 2 3 4 5 6 7 8 10 32 40 44 70 86 91 92 99 363